import { Component, inject, signal } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';
import { DISABILITY_TYPE_SERVICE, DisabilityTypeService } from '../../../../api/services/disability-type.api';
import { NOTIFICATION_SERVICE } from '../../../../shared/notification/notification';
import { DisabilityKind } from '../../../../api/app-types/disability-type.app';
import {
	createErrorNotification,
	createSuccessNotification,
} from '../../../../shared/notification/notification.factory';
import { LvrButton } from '../../../../core/components/lvr-button/lvr-button';

@Component({
	selector: 'lvr-disability-type-delete-dialog',
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, TranslocoPipe, LvrButton],
	templateUrl: './disability-type-delete-dialog.html',
	providers: [
		{
			provide: DISABILITY_TYPE_SERVICE,
			useClass: DisabilityTypeService,
		},
	],
})
export class DisabilityTypeDeleteDialog {
	private readonly api = inject(DISABILITY_TYPE_SERVICE);
	private readonly dialogRef = inject(MatDialogRef<DisabilityTypeDeleteDialog>);
	private readonly ntfySrv = inject(NOTIFICATION_SERVICE);
	private readonly data: { kind: DisabilityKind; clientId: number; onDeleted: () => Promise<void> } =
		inject(MAT_DIALOG_DATA);
	public readonly kind = this.data.kind;
	public readonly loading = signal(false);

	public async deleteType() {
		this.loading.set(true);

		try {
			await this.api.delete(this.data.clientId, this.kind.id);
			await this.data.onDeleted();
			this.ntfySrv.addNotification(createSuccessNotification('Behinderungsart wurde erfolgreich gelöscht'));
			this.dialogRef.close(true);
		} catch {
			this.ntfySrv.addNotification(createErrorNotification('Fehler bei der Löschung der Behinderungsart'));
		} finally {
			this.loading.set(false);
		}
	}
}
